"use strict";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getGridUtilityClass = getGridUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("@mui/utils/generateUtilityClasses"));
var _generateUtilityClass = _interopRequireDefault(require("@mui/utils/generateUtilityClass"));
function getGridUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiGrid', slot);
}
var SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
var DIRECTIONS = [
    'column-reverse',
    'column',
    'row-reverse',
    'row'
];
var WRAPS = [
    'nowrap',
    'wrap-reverse',
    'wrap'
];
var GRID_SIZES = [
    'auto',
    true,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
var gridClasses = (0, _generateUtilityClasses.default)('MuiGrid', [
    'root',
    'container',
    'item',
    'zeroMinWidth'
].concat(// spacings
_to_consumable_array(SPACINGS.map(function(spacing) {
    return "spacing-xs-".concat(spacing);
})), // direction values
_to_consumable_array(DIRECTIONS.map(function(direction) {
    return "direction-xs-".concat(direction);
})), // wrap values
_to_consumable_array(WRAPS.map(function(wrap) {
    return "wrap-xs-".concat(wrap);
})), // grid sizes for all breakpoints
_to_consumable_array(GRID_SIZES.map(function(size) {
    return "grid-xs-".concat(size);
})), _to_consumable_array(GRID_SIZES.map(function(size) {
    return "grid-sm-".concat(size);
})), _to_consumable_array(GRID_SIZES.map(function(size) {
    return "grid-md-".concat(size);
})), _to_consumable_array(GRID_SIZES.map(function(size) {
    return "grid-lg-".concat(size);
})), _to_consumable_array(GRID_SIZES.map(function(size) {
    return "grid-xl-".concat(size);
}))));
var _default = exports.default = gridClasses;
